/* eslint-disable valid-jsdoc */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */

import { GET_ADS_TXT_DATA } from '@/graphql/adsTxt/ads.query'
import { DOMAIN, REACT_APP_ENV, S3_PREFIX, SITE_NAME } from '@/shared/constants'
import { DocumentNode } from '@apollo/client'
import { DefinitionNode } from 'graphql'
import queryGraphql from './components/queryGraphql'

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat']

// Timer Function
export const countDownCalculations = (dateData: number | Date | string) => {
  let diff = (Date.parse(dateData.toString()) - Date.parse(new Date().toString())) / 1000

  const timeLeft = {
    years: '00',
    days: '00',
    hours: '00',
    min: '00',
    sec: '00'
  }

  if (diff >= 365.25 * 86400) {
    timeLeft.years = String(Math.floor(diff / (365.25 * 86400))).padStart(2, '0')
    diff -= Number(timeLeft.years) * 365.25 * 86400
  }
  if (diff >= 86400) {
    timeLeft.days = String(Math.floor(diff / 86400)).padStart(2, '0')
    diff -= Number(timeLeft.days) * 86400
  }
  if (diff >= 3600) {
    timeLeft.hours = String(Math.floor(diff / 3600)).padStart(2, '0')
    diff -= Number(timeLeft.hours) * 3600
  }
  if (diff >= 60) {
    timeLeft.min = String(Math.floor(diff / 60)).padStart(2, '0')
    diff -= Number(timeLeft.min) * 60
  }
  timeLeft.sec = String(Math.floor(diff)).padStart(2, '0')

  return timeLeft
}

// Add 0 value in start
export const addLeadingZeros = (value: string | number) => {
  value = String(value)
  while (value.length < 2) {
    value = '0' + value
  }
  return value
}

// 10 Nov 2020, Tuesday, 7:30 PM IST
export const convertDate = (data: string | number | Date | undefined) => {
  const t = new Date(Number(data))
  const Day = t.toLocaleString('en-US', { day: '2-digit', timeZone: 'Asia/Kolkata' })
  const Month = t.toLocaleString('en-US', { month: 'short', timeZone: 'Asia/Kolkata' })
  const Year = t.getFullYear()
  const sDay = t.getDay()
  const timeWithAMPM = t.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  })
  return Day + ' ' + Month + ' ' + Year + ', ' + daysOfWeek[sDay] + ', ' + timeWithAMPM + ' IST'
}

// comment date example : Aug 18 2020 11:34 AM
export const convertDateAMPM = (data: string | number) => {
  const t = new Date(Number(data))
  const Day = t.getDate()
  const Month = t.toLocaleString('en-us', { month: 'short' })
  const Year = t.getFullYear()
  const timeWithAMPM = t.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  })
  return Month + ' ' + Day + ' ' + Year + ' ' + timeWithAMPM
}

export const convertToDayDate = (data: string | number) => {
  const t = new Date(Number(data))
  const Day = t.getDate()
  const Month = t.toLocaleString('en-us', { month: 'short', timeZone: 'Asia/Kolkata' })
  const Year = t.getFullYear()

  const weekDay = t.toLocaleString('en-us', { weekday: 'long' })
  // const timeWithAMPM = t.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'Asia/Kolkata' })
  return weekDay + ', ' + Day + ' ' + Month + ' ' + Year
}

export const convertDateDDMT = (data: string | number | Date | undefined) => {
  const t = new Date(Number(data))
  const Day = t.getDate()
  const Month = t.toLocaleString('en-us', { month: 'short' })
  const Year = t.getFullYear()
  const timeWithAMPM = t.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  })
  return Day + ' ' + Month + ' ' + Year + ', ' + timeWithAMPM
}

// 16 Jan 2020, 16:00 IST
export const convertDt24hFormat = (data: string | number | Date | undefined) => {
  const t = new Date(Number(data))
  const dateWithTime = t.toLocaleString('en-gb', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'Asia/Kolkata'
  })
  return dateWithTime + ' ' + 'IST'
}

// 12 jan 2021
export const convertDt24h = (data: string | number | Date | undefined) => {
  const t = new Date(Number(data))
  const Day = t.getDate()
  const Month = t.toLocaleString('en-us', { month: 'short' })
  const Year = t.getFullYear()
  return Day + ' ' + Month + ' ' + Year
}

// only Date and month
export const dateMonth = (data: string | number | Date | undefined) => {
  const t = new Date(Number(data))
  const Day = t.getDate()
  const Month = t.toLocaleString('en-us', { month: 'short' })
  return Month + ' ' + Day
}

export const playerType = (data: string) => {
  switch (data) {
    case 'bbf':
      return 'Best Bowling Figure'
    case 'hrs':
      return 'Highest Run Scorer'
    case 'hs':
      return 'Highest Score'
    case 'hwt':
      return 'Highest Wicket Taker'
    default:
      return ''
  }
}

export const scoreType = (data: string) => {
  switch (data) {
    case 'bbf':
      return 'Best'
    case 'hwt':
      return 'Wickets'
    case 'hs':
    case 'hrs':
      return 'Runs'
    default:
      return ''
  }
}

export const getImgURL = (url: string) => {
  return url ? (url?.indexOf('cricketbazaar.com') !== -1 ? url : S3_PREFIX + url) : ''
}

// is Bottom reached
export function isBottomReached(id: string, callBack: (_: boolean) => void) {
  const controller = new AbortController()
  function handleScroll() {
    const ele = document.getElementById(id)
    if (ele) {
      if (ele.offsetTop <= window.scrollY + window.innerHeight) {
        callBack(ele.offsetTop <= window.scrollY + window.innerHeight)
        controller.abort()
      }
    }
  }
  window.addEventListener('scroll', handleScroll, { signal: controller.signal })
  // // document.body.addEventListener('scroll', (e) => {
  // document.getElementById('inner-body').onscroll = (e) => {
  //   const ele = document.getElementById(id)
  //   console.log(e.target?.scrollTop)
  //   if (ele) {
  //     callBack(ele.offsetTop <= e.target?.scrollTop + window.innerHeight)
  //   } else {
  //     document.getElementById('body').onscroll = null
  //   }
  // }
  // }, { capture: true })
  // window.onscroll = () => {
  //   const ele = document.getElementById(id)
  //   if (ele) {
  //     callBack(ele.offsetTop <= window.scrollY + window.innerHeight)
  //   } else {
  //     document.getElementsByTagName('body')[0].onscroll = null
  //   }
  // }
}

// Scroll to a element
export function scrollToElement(id: string, block: ScrollLogicalPosition | undefined = 'start') {
  const ele = document.getElementById(id)
  if (ele) {
    ele.scrollIntoView({ behavior: 'smooth', block })
  }
}

export const bottomReached = ({
  target
}: {
  target: { offsetHeight: number; scrollTop: number; scrollHeight: number }
}) => {
  return target.offsetHeight + target.scrollTop + 5 >= target.scrollHeight
}

/**
 * Set cookie with expiry date in days.
 * It's only work on client side
 * @param {string} cName cookie name
 * @param {string} cValue cookie value
 * @param {number} exDays exDays should be a number of days
 * @param {number} exMinutes exMinutes should be a number of minutes
 */
export const setCookie = ({
  cName,
  cValue,
  exDays,
  exMinutes
}: {
  cName: string
  cValue: string
  exDays?: number
  exMinutes?: number
}) => {
  if (typeof window !== 'undefined') {
    const d = new Date()
    d.setTime(
      d.getTime() + (exDays ? exDays * 24 * 60 * 60 * 1000 : exMinutes ? exMinutes * 60 * 1000 : 0)
    )
    const expires = 'expires=' + d.toUTCString()
    document.cookie = cName + '=' + cValue + ';' + expires + ';path=/'
  }
}
/**
 * get cookie value.
 * It's only work on client side
 * @param {string} cName cookie name
 * @return {string} cookie value
 */
export const getCookie = (cName: string) => {
  if (typeof window !== 'undefined') {
    const name = cName + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }
  return ''
}
/**
 * delete all cookies.
 * It's also work on client side
 */
export const clearCookie = () => {
  const cookies = document.cookie.split(';')
  cookies.forEach(c => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
  })
}

export const dateCheck = (data: string | number | Date | undefined) => {
  if (isNaN(Number(data))) {
    return new Date(data as any)
  } else {
    return new Date(Number(data))
  }
}

/**
 * @description - Get time zone of your machine -> Ex -> 'Asia/Calcutta'
 * @return {string} string
 */
export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/*
 * map data for Fixtures data
 */
export function mapFixturesData(fixturesData: any[]) {
  const result: { aMatch?: any; oSeries?: any }[] = []
  if (!fixturesData?.length) return []
  fixturesData?.forEach((fixture: any) => {
    const existInResult = result.findIndex(
      (res: { aMatch?: any; oSeries?: any }) => res?.oSeries?._id === fixture?.oSeries?._id
    )
    if (existInResult !== -1) {
      result[existInResult]?.aMatch?.push(fixture)
    } else {
      result.push({ oSeries: fixture.oSeries, aMatch: [fixture] })
    }
  })
  const data = result?.toSorted((a, b) => {
    const first = a?.aMatch?.some(
      (m: any) =>
        m?.odds?.favOdds &&
        ((m?.oStatus?.sValue || m?.sStatusStr) === 'live' ||
          (m?.oStatus?.sValue || m?.sStatusStr) === 'scheduled') &&
        (m?.odds?.favOdds?.lay > 0 || m?.odds?.favOdds?.back > 0)
    )
    const second = b?.aMatch?.some(
      (m: any) =>
        m?.odds?.favOdds &&
        ((m?.oStatus?.sValue || m?.sStatusStr) === 'live' ||
          (m?.oStatus?.sValue || m?.sStatusStr) === 'scheduled') &&
        (m?.odds?.favOdds?.lay > 0 || m?.odds?.favOdds?.back > 0)
    )
    if (!first && !second) return 0
    if (first && !second) return -1
    if (!first && second) return 1
    return 0
  })
  return data
}

/**
 * Repalce Large name to Short Name
 * @param Team1 Object
 * @param Team2 Object
 * @param statusNote string
 * @return Replaced String
 */
export const replaceStringToShort = (teamA: any, teamB: any, data: any) => {
  if (teamA?.sTitle && data?.includes(teamA?.sTitle)) {
    return data.replace(teamA?.sTitle, teamA?.sAbbr)
  } else if (teamB && data?.includes(teamB?.sTitle)) {
    return data.replace(teamB?.sTitle, teamB?.sAbbr)
  } else {
    return data
  }
}

/**
 * Check SEO status code and return object to completable with next js
 * @param data Object
 * @param statusNote string
 * @return Modified Object
 * @developer Kuldip Dobariya
 */
type redirectionTypes = {
  eCode: number
  sSlug: string
  eType: string
}
export const checkRedirectionStatus = (data: redirectionTypes) => {
  if (data?.eCode) {
    const obj = { redirectStatus: true, eCode: data.eCode }
    if (data?.eCode === 308 || data?.eCode === 307) {
      if (data?.eType === 'fa') {
        return { ...obj, redirect: 'fantasy-cricket-tips/' + data?.sSlug }
      } else {
        return { ...obj, redirect: data?.sSlug ? getSlugUrl(`/${data?.sSlug}`)?.substring(1) : '' }
      }
    } else if (data?.eCode === 410 || data?.eCode === 451) {
      return { ...obj, props: { statusCode: data?.eCode } }
    } else return {}
  } else {
    return {
      redirectStatus: false
    }
  }
}

/**
 * Convert string query params to object
 * @param params string
 * @return Query params object
 * @developer Kuldip Dobariya
 */
export const parseParams = (params = '') => {
  const urlParams = new URLSearchParams(params)
  const value = Object.fromEntries(urlParams.entries())
  return value
}

export const stripHtml = (content: string) => {
  if (content) {
    const str = content.toString()
    return str.replace(/(<([^>]+)>)/gi, '')
  } else return ''
}

/**
 * @description - Capitalize first letter of string For example: 'hello test' => 'Hello Test'
 * @param {string} string
 * @return {string} string
 */
export const capitalizeFirstLetter = (str: string) => {
  const arr = str.split(' ')
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
  }
  return arr.join(' ')
}

/**
 * @description get robots txt
 * @return Robots txt rules
 * @developer Kuldip Dobariya
 */
export const getRobotsTxt = () => {
  if (REACT_APP_ENV === 'production') {
    return `User-Agent: *
Allow: /

Disallow: /search/*

Sitemap: https://www.cricketbazaar.com/sitemap.xml
Sitemap: https://www.cricketbazaar.com/news-sitemap.xml
Sitemap: https://www.cricketbazaar.com/hindi-news-sitemap.xml


# allow adsense bot to parse no-index content 
User-agent: Mediapartners-Google
Disallow:`
  } else {
    return `# https://www.robotstxt.org/robotstxt.html
User-agent: *
Disallow: /
`
  }
}

export const getDeepLink = () => {
  if (REACT_APP_ENV === 'production') {
    return `{
        "webcredentials": {
          "apps": [
            "CV4DJ2NSG4.com.sportsbuzz.livescore"
          ]
        },
        "activitycontinuation": {
          "apps": [
            "CV4DJ2NSG4.com.sportsbuzz.livescore"
          ]
        },
        "applinks": {
          "details": [
            {
              "appID": "CV4DJ2NSG4.com.sportsbuzz.livescore",
              "appIDs": [
                "CV4DJ2NSG4.com.sportsbuzz.livescore"
              ],
              "paths": [
                "/*"
              ],
              "components": [
                {
                  "/": "/*"
                }
              ]
            }
          ]
        }
      }`
  } else {
    return null
  }
}

/** Make canonical URL for all pages
 * @params oSeo (GraphQL SEO data as a object)
 * @params routerAsPath (current page URL as a string)
 * @return String (Canonical URL)
 * @developer Kuldip Dobariya
 */
type canonicalType = {
  oSeo: {
    eType?: string
    sCUrl?: string
  }
}
export const makeCanonical = (data: canonicalType, routerAsPath: string) => {
  if (data?.oSeo?.eType === 'ma') {
    const url = routerAsPath?.split('?')[0]?.substring(1)
    return `${DOMAIN}${url}`
  } else if (data?.oSeo?.sCUrl) {
    // if (data?.oSeo?.eType === 'ad') return `${DOMAIN}${allRoutes.authorDetail(data?.oSeo?.sCUrl).substring(1)}`
    return `${DOMAIN}${data?.oSeo?.sCUrl}`
  } else {
    const url = routerAsPath?.split('?')[0]?.substring(1)
    return `${DOMAIN}${url}`
  }
}

export const getMetaTagImg = (data: any, key: string) => {
  if (data?.oSeo && data?.oSeo[key]?.sUrl) return getImgURL(data?.oSeo[key]?.sUrl)
  else if (data?.oTImg?.sUrl) return getImgURL(data?.oTImg?.sUrl)
  else if (data?.oImg?.sUrl) return getImgURL(data?.oImg?.sUrl)
  else return ''
}

export function triggerEvent(type: any, detail = {}, elem?: any) {
  if (!type || typeof document === 'undefined') return
  if (!elem) {
    elem = document
  }
  const event = new CustomEvent(type, {
    bubbles: true,
    cancelable: true,
    detail: detail
  })

  return elem.dispatchEvent(event)
}

export function showToast(toast: {
  message?: string
  heading?: string
  toastType?: 'success' | 'warning' | 'danger'
}) {
  triggerEvent('notify', toast)
}

type metaDataType = {
  sTitle: string
  sDescription: string
  sSlug: string
  aKeywords: string[]
  oFB: {
    sTitle: string
    sUrl: string
    sDescription: string
  }
}

export const makeMetadata = (data: Partial<metaDataType>) => {
  const metaTags = {
    title: data?.sTitle || 'Cricket Bazaar',
    metadataBase: new URL(DOMAIN + (data?.sSlug ? getSlugUrl(data?.sSlug) : '')),
    alternates: {
      canonical: new URL(DOMAIN + (data?.sSlug ? getSlugUrl(data?.sSlug) : ''))
    },
    description: data?.sDescription || data?.sDescription,
    Author: SITE_NAME,
    keywords: data?.aKeywords,
    openGraph: {
      title: data?.oFB?.sTitle || data?.sTitle || data?.sTitle || SITE_NAME,
      type: 'website',
      url: '',
      site_name: SITE_NAME,
      image: {
        alt: data?.oFB?.sTitle || data?.sTitle || data?.sTitle || SITE_NAME,
        width: 640,
        height: 400,
        url: getMetaTagImg(data, 'oFB'),
        type: `image/${data?.oFB?.sUrl?.split('.')[1] || 'jpeg'}`
      },
      description: data?.oFB?.sDescription || data?.sDescription || data?.sDescription,
      locale: 'en_US'
    }
  }
  return metaTags
}

export async function parallelCalls(apis: any[]) {
  try {
    const data = await Promise.allSettled(apis)
    return data?.map(api => {
      if (api.status === 'rejected') {
        throw new Error(api?.reason)
        // return { error: api.reason }
      } else {
        return api?.value?.data || api?.value
      }
    })
  } catch (err) {
    console.log({ err })
  }
}
function queryCombineContainer(opName: string, query: DocumentNode, variables: unknown) {
  const _query = query
  const _variables = variables

  function add(query: any, variables: any) {
    const opDefs: (DefinitionNode & { operation?: any })[] = _query.definitions
      .concat(query.definitions)
      .filter(def => def.kind === 'OperationDefinition')

    const newVars =
      _variables && variables
        ? {
            ..._variables,
            ...variables
          }
        : variables || _variables

    const definitions = [
      {
        kind: 'OperationDefinition',
        directives: opDefs?.flatMap((def: any) => def?.directives || []),
        name: { kind: 'Name', value: opName },
        operation: opDefs[0]?.operation || '',
        selectionSet: {
          kind: 'SelectionSet',
          selections: opDefs?.flatMap((def: any) => def?.selectionSet?.selections)
        },
        variableDefinitions: opDefs?.flatMap((def: any) => def?.variableDefinitions || [])
      }
    ]

    const _query_ = {
      kind: 'Document',
      definitions
    }
    return queryCombineContainer(opName, _query_ as any, newVars)
  }
  return { add, query: _query, variables: _variables }
}

export function combineQuery(queryName: string) {
  return {
    queryName,
    add: (query: DocumentNode, variables: unknown) =>
      queryCombineContainer(queryName, query, variables)
  }
}

export const ViewPortEndpoints = ({ breakpoints = [], currentSize }: any) => {
  let isIntersecting = false
  for (let i = 0; i < breakpoints.length; i++) {
    const [start, end] = breakpoints[i]
    if (currentSize > start && currentSize < end) {
      isIntersecting = true
      break
    } else {
      isIntersecting = false
    }
  }
  return { isIntersecting }
}

export async function getAdsTXTdata() {
  try {
    const data = await queryGraphql(GET_ADS_TXT_DATA, { input: { eType: 'w' } })
    return data
  } catch (err: any) {
    console.log('ERR: IN ADS TXT', err)
  }
}

export function cMerge(...params: any[]) {
  let className = ''
  params?.forEach(param => {
    if (typeof param === 'string') {
      className += ' '
      className += param
    } else {
      if (!param) return
      for (const key in param) {
        if (param[key]) {
          className += ' '
          className += Array.isArray(param) ? param[key as any] : key
        }
      }
    }
  })
  return className
}

export const dayCal = (dayArray: any[]) => {
  const dt = new Date()
  let daysInPreviousMonth
  const currentDate = dt.getDate()
  const currentMonth = dt.getMonth()
  const currentYear = dt.getFullYear()
  const currentDay = dt.getDay()
  let incDay = currentDay
  let decDay = currentDay
  let incYear = currentYear
  let decYear = currentYear
  let decDate = currentDate
  let incDate = currentDate
  let decMonth = currentMonth
  let incMonth = currentMonth
  const daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate()
  if (currentMonth === 0) {
    daysInPreviousMonth = new Date(currentYear - 1, 12, 0).getDate()
  } else {
    daysInPreviousMonth = new Date(currentYear, currentMonth, 0).getDate()
  }
  for (let i = 5; i > 0; i--) {
    decDay = decDay - 1
    if (decDay < 0) {
      decDay = 6
    }
    decDate = decDate - 1
    if (decDate < 1) {
      decDate = daysInPreviousMonth
      decMonth = currentMonth - 1
      if (decMonth === -1) {
        decMonth = 11
        decYear = currentYear - 1
        dayArray.push({
          date: decDate + ' ' + months[decMonth] + ' ' + decYear,
          show: decDate + ' ' + months[decMonth],
          day: daysOfWeek[decDay]
        })
      } else {
        dayArray.push({
          date: decDate + ' ' + months[decMonth] + ' ' + decYear,
          show: decDate + ' ' + months[decMonth],
          day: daysOfWeek[decDay]
        })
      }
    } else {
      dayArray.push({
        date: decDate + ' ' + months[decMonth] + ' ' + decYear,
        show: decDate + ' ' + months[decMonth],
        day: daysOfWeek[decDay]
      })
    }
  }
  dayArray.reverse()
  for (let i = 0; i < 8; i++) {
    if (incDate > daysInCurrentMonth) {
      incDate = 1
      incMonth = currentMonth + 1
      if (incMonth === 12) {
        incMonth = 0
        incYear = incYear + 1
        dayArray.push({
          date: incDate + ' ' + months[incMonth] + ' ' + incYear,
          show: incDate + ' ' + months[incMonth],
          day: i === 0 ? 'Today' : daysOfWeek[incDay]
        })
      } else {
        dayArray.push({
          date: incDate + ' ' + months[incMonth] + ' ' + incYear,
          show: incDate + ' ' + months[incMonth],
          day: i === 0 ? 'Today' : daysOfWeek[incDay]
        })
      }
    } else {
      dayArray.push({
        date: incDate + ' ' + months[incMonth] + ' ' + incYear,
        show: incDate + ' ' + months[incMonth],
        day: i === 0 ? 'Today' : daysOfWeek[incDay]
      })
    }
    incDate = incDate + 1
    incDay = incDay + 1
    if (incDay > 6) {
      incDay = 0
    }
  }
  return dayArray
}

export const currentDateMonth = (date?: string) => {
  const currentMonth = date ? new Date(date).getMonth() + 1 : new Date().getMonth() + 1
  const currentYear = date ? new Date(date).getFullYear() : new Date().getFullYear()
  const currentDay = date ? new Date(date).getDate() : new Date().getDate()
  return currentYear + '-' + addLeadingZeros(currentMonth) + '-' + addLeadingZeros(currentDay)
}

export const decodeDay = (data: string) => {
  const daySplit = data.split(' ')
  const monthNumber = monthCheck(daySplit[1])
  return daySplit[2] + '-' + monthNumber + '-' + addLeadingZeros(daySplit[0])
}

export const monthCheck = (data: string) => {
  switch (data) {
    case 'Jan':
      return '01'
    case 'Feb':
      return '02'
    case 'Mar':
      return '03'
    case 'Apr':
      return '04'
    case 'May':
      return '05'
    case 'Jun':
      return '06'
    case 'Jul':
      return '07'
    case 'Aug':
      return '08'
    case 'Sep':
      return '09'
    case 'Oct':
      return '10'
    case 'Nov':
      return '11'
    case 'Dec':
      return '12'
    default:
      return ''
  }
}

export const calculateAge = (timestamp: any) => {
  const birthDate = new Date(timestamp)
  const currentDate = new Date()
  const age = currentDate.getFullYear() - birthDate.getFullYear()
  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
  ) {
    return age - 1
  }

  return age
}

export const getPlayerRole = (role?: string) => {
  switch (role) {
    case 'bowl':
      return 'Bowler'
    case 'bat':
      return 'Batsman'
    case 'all':
      return 'All Rounder'
    // case 'wk':
    //   return 'Wicket Keeper'
    case 'allcap':
      return 'All Rounder'
    case 'bowlcap':
      return 'Bowler'
    case 'batcap':
      return 'Batsman'
    default:
      return 'Batsman'
  }
}

export function getSlugUrl(pathname: string): string {
  if (pathname) {
    const changedPaths: Record<string, string> = {
      'live-score': '/live-cricket-score/',
      teams: '/teams/',
      players: '/players/',
      series: '/series/',
      news: '/news/'
    }
    return pathname.replace(/\/cricket\/(live-score|teams|players|series|news)\//g, (match, p1) => {
      return changedPaths[p1] || match
    })
  }
  return ''
}

export function debounce(func: (args: any) => void, immediate?: number) {
  let timeout: any
  return function executedFunction(this: any) {
    const context = this
    const args: any = arguments

    const later = () => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, 500)
    if (callNow) func.apply(context, args)
  }
}

// month and year
export const MonthYear = (data: string) => {
  const splitString = data.split('-')
  const d = new Date(data)
  const month = d.getMonth() + 1
  return months[month - 1] + ' ' + splitString[0]
}

export const getMatchFormat = (key: string) => {
  switch (key) {
    case 'odi':
      return 'ODI'
    case 'lista':
      return 'List A'
    case 't20i':
      return 'T20I'
    case 't20':
      return 'T20'
    case 'test':
      return 'Test'
    case 'firstclass':
      return 'First class'
    default:
      return key
  }
}

export const abbreviateNumber = (n: number) => {
  if (n < 1e3) return n
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K'
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M'
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B'
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T'
}

export function getBannerUrl(d: string, data: any) {
  switch (d) {
    case 'home_left_banner':
      return data?.homePage?.leftBanner?.bannerUrl
    case 'home_top_banner':
      return data?.homePage?.topBanner?.bannerUrl
    case 'match_details_right_banner':
      return data?.matchDetailPage?.rightBanner?.bannerUrl
    case 'match_details_top_banner':
      return data?.matchDetailPage?.topBanner?.bannerUrl
    case 'series_right_banner':
      return data?.serieslPage?.rightBanner?.bannerUrl
    case 'series_top_banner':
      return data?.serieslPage?.topBanner?.bannerUrl
    case 'interstitial_banner':
      return data?.interstitial?.bannerUrl
    default:
      return null
  }
}

export function isGetAdd(d: string, data: any) {
  switch (d) {
    case 'home_left_banner':
      return data?.homePage?.leftBanner?.bShow
    case 'home_top_banner':
      return data?.homePage?.topBanner?.bShow
    case 'match_details_right_banner':
      return data?.matchDetailPage?.rightBanner?.bShow
    case 'match_details_top_banner':
      return data?.matchDetailPage?.topBanner?.bShow
    case 'series_right_banner':
      return data?.serieslPage?.rightBanner?.bShow
    case 'series_top_banner':
      return data?.serieslPage?.topBanner?.bShow
    case 'interstitial_banner':
      return data?.interstitial?.bShow
    default:
      return null
  }
}

export function getImageUrl(d: string, data: any) {
  switch (d) {
    case 'home_left_banner':
      return data?.homePage?.leftBanner?.imgUrl
    case 'home_top_banner':
      return data?.homePage?.topBanner?.imgUrl
    case 'match_details_right_banner':
      return data?.matchDetailPage?.rightBanner?.imgUrl
    case 'match_details_top_banner':
      return data?.matchDetailPage?.topBanner?.imgUrl
    case 'series_right_banner':
      return data?.serieslPage?.rightBanner?.imgUrl
    case 'series_top_banner':
      return data?.serieslPage?.topBanner?.imgUrl
    case 'interstitial_banner':
      return data?.interstitial?.imgUrl
    default:
      return null
  }
}

// get angle for wagonWheel cords
export function degreeToRadians(d: any) {
  return (d * Math.PI) / 180
}

// new cords
export function renderNewCords(x: number, y: number) {
  // const element = document?.getElementById('wagonWheel')
  if (x === 0 && y === 0) return { x: 0, y: 0 }
  if (x && y !== 0) {
    const paperWidth: any = 400
    const paperHalf = parseInt(paperWidth, 10) / 2
    const nx: any = paperHalf + x * Math.cos(degreeToRadians(-y))
    const ny: any = paperHalf + x * Math.sin(degreeToRadians(-y))
    if (x != 0 && y != 0) {
      const d = { x: parseInt(nx), y: parseInt(ny) }
      return d
    }
  }
  return null
}

// X axis as per run
export function getXaxis(x: any, run: any) {
  if (x >= 350 && x !== 0) {
    if (parseInt(run) == 6) {
      x = 192
    } else if (parseInt(run) >= 4) {
      x = 184
    } else {
      x = 180
    }
  } else if (x > 250 && x < 350) {
    x -= 150
  } else if (x > 140 && x <= 250) {
    x -= 100
  } else if (x > 55 && x <= 140) {
    x -= 50
  }

  if (parseInt(run) < 4 && x > 175 && x !== 0) {
    x = 150
  }
  return x
}

/**
 * Javascript sort array of objects using array of priority
 * @param data array of object
 * @param order string array (what you want to order it)
 * @param key string (Object key name)
 * @return order array
 * @developer Kuldip Dobariya
 */
export const arraySortByOrder = ({ data = [], order, key }: any) => {
  return data.sort((x: any, y: any) => order.indexOf(x[key]) - order.indexOf(y[key]))
}

export const convertHtmlToPlainText = (html: any) => {
  if (!html) return ''

  try {
    // First, remove all HTML tags
    let plainText = html.replace(/<[^>]*>/g, '')

    // Replace common HTML entities
    plainText = plainText
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&rdquo;/g, '"')
      .replace(/&ldquo;/g, '"')
      .replace(/&rsquo;/g, "'")
      .replace(/&lsquo;/g, "'")
      .replace(/&mdash;/g, '—')
      .replace(/&ndash;/g, '–')
      .replace(/\s+/g, ' ') // Replace multiple spaces with single space
      .trim()

    return plainText
  } catch (error) {
    console.error('Error converting HTML to plain text:', error)
    return html
  }
}

export const getYearFromTimestamp = (data: number) => {
  const t = new Date(Number(data))
  const Month = t.toLocaleString('en-us', { month: 'short' })
  const Year = t.getFullYear()
  return Month + ' ' + Year
}

// Convert Seconds into minutes
export const convertHMS = (value: string | number, isLong = false) => {
  const sec = parseInt(value.toString(), 10) // convert value to number if it's string
  const hours = Math.floor(sec / 3600) // get hours
  let minutes = Math.floor((sec - hours * 3600) / 60) // get minutes
  let seconds = sec - hours * 3600 - minutes * 60 //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) {
    // Removed unused variable 'formattedHours'
  }
  if (minutes < 10) {
    const formattedMinutes = '0' + minutes
    minutes = parseInt(formattedMinutes, 10)
  }
  if (seconds < 10) {
    seconds = parseInt('0' + seconds.toString(), 10)
  }
  if (hours > 0) {
    return hours + ':' + minutes + ':' + seconds // Return is HH : MM : SS
  } else {
    if (!isLong) {
      return minutes + ':' + seconds // MM : SS
    } else return `${minutes}min ${seconds}sec`
  }
}

export function formatDateWithConditions(utcDate: string | Date): string {
  const istDate = new Date(utcDate)

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  // Calculate difference in days
  const diffTime = istDate.getTime() - today.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  // Format for dates more than 2 days away
  if (diffDays > 2) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]
    return `${String(istDate.getDate()).padStart(2, '0')} ${months[istDate.getMonth()]} ${istDate.getFullYear()}`
  }

  // Format time
  const hours = istDate.getHours()
  const formattedTime = `${hours > 12 ? hours - 12 : hours}:${String(istDate.getMinutes()).padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`

  // Check if date is today or tomorrow
  if (
    istDate.getDate() === today.getDate() &&
    istDate.getMonth() === today.getMonth() &&
    istDate.getFullYear() === today.getFullYear()
  ) {
    return `Today ${formattedTime}`
  } else if (
    istDate.getDate() === tomorrow.getDate() &&
    istDate.getMonth() === tomorrow.getMonth() &&
    istDate.getFullYear() === tomorrow.getFullYear()
  ) {
    return `Tomorrow ${formattedTime}`
  }

  return `${String(istDate.getDate()).padStart(2, '0')} ${months[istDate.getMonth()]} ${istDate.getFullYear()}`
}

export async function fetchIp(): Promise<string> {
  try {
    const res = await fetch('https://api.ipify.org?format=json')
    const data = await res.json()
    return data.ip
  } catch (error) {
    throw new Error('Failed to fetch IP')
  }
}

type IPLocationInfo = {
  ipVersion: number
  ipAddress: string
  latitude: number
  longitude: number
  countryName: string
  countryCode: string
  timeZone: string
  zipCode: string
  cityName: string
  regionName: string
  isProxy: boolean
  continent: string
  continentCode: string
  currency: {
    code: string
    name: string
  }
  language: string
  timeZones: string[]
  tlds: string[]
}

export async function fetchIpData(ip: string): Promise<IPLocationInfo> {
  try {
    const res = await fetch(`https://freeipapi.com/api/json/${ip}`)
    const data = await res.json()
    return data
  } catch (error) {
    throw new Error('Failed to fetch IP data')
  }
}
